var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 7.00139H9C7.9 7.00139 7 7.90139 7 9.00139V23.0014C7 24.1014 7.9 25.0014 9 25.0014H23C24.1 25.0014 25 24.1014 25 23.0014V9.00139C25 7.90139 24.1 7.00139 23 7.00139ZM23 23.0014H9V9.00139H23V23.0014ZM21.99 13.0014L20.58 11.5814L13.99 18.1714L11.41 15.6014L9.99 17.0114L13.99 21.0014L21.99 13.0014Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/Checkbox.ca977aaa604a3c247397e9364c0c356e.svg";
export { ForwardRef as ReactComponent };